<template>
   <div>
    <t-form label-width="100px">
      <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
      <t-form-item label="排列方向">
        <t-radio-group v-model="attribute.direction" size="small">
          <t-radio-button value="x">竖向</t-radio-button>
          <t-radio-button value="y">横向</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <e-collapse title="标题" :expand="false">
        <t-form-item label="标题文本">
          <t-input v-model="attribute.title.text" size="small" :maxcharacter="52"/>
        </t-form-item>
        <t-form-item label="标题大小">
          <t-input-number v-model="attribute.title.textStyle.fontSize" size="small" :min="2" :max="100" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="标题颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.title.textStyle.color" size="small"/>
        </t-form-item>
        <t-form-item label="标题位置(X)">
          <e-chart-position v-model="attribute.title.left" :direction="'x'"/>
        </t-form-item>
        <t-form-item label="标题位置(Y)">
          <e-chart-position v-model="attribute.title.top" :direction="'y'"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="内边距" :expand="false">
        <t-form-item label="内边距(左)">
          <t-input-number size="small" v-model="attribute.grid.x" :min="0" :max="200" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="内边距(上)">
          <t-input-number size="small" v-model="attribute.grid.y" :min="0" :max="200" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="内边距(右)">
          <t-input-number size="small" v-model="attribute.grid.x2" :min="0" :max="200" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="内边距(下)">
          <t-input-number size="small" v-model="attribute.grid.y2" :min="0" :max="200" :decimal-places="0"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="x轴" :expand="false">
        <t-form-item label="x轴">
          <t-switch v-model="attribute.xAxis.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <div v-show="attribute.xAxis.show">
          <t-form-item label="x轴指示文字">
            <t-input v-model="attribute.xAxis.name" size="small" :maxcharacter="40"/>
          </t-form-item>
          <t-form-item label="x轴线显示">
            <t-switch v-model="attribute.xAxis.axisLine.show" :label="['开', '关']" size="small"/>
          </t-form-item>
          <t-form-item label="x轴线颜色">
            <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.xAxis.axisLine.lineStyle.color" size="small"/>
          </t-form-item>
          <t-form-item label="x轴刻度线">
            <t-switch v-model="attribute.xAxis.axisTick.show" :label="['开', '关']" size="small"/>
          </t-form-item>
          <t-form-item label="x轴字体颜色">
            <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.xAxis.axisLabel.color" size="small"/>
          </t-form-item>
          <t-form-item label="x轴字号">
            <t-input-number v-model="attribute.xAxis.axisLabel.fontSize" :min="1" :max="100" size="small" :decimal-places="0"/>
          </t-form-item>
          <t-form-item label="x轴字体倾斜">
            <t-input-number v-model="attribute.xAxis.axisLabel.rotate" :min="-180" :max="180" size="small" :decimal-places="0"/>
          </t-form-item>
          <t-form-item label="x轴网格线">
            <t-switch v-model="attribute.xAxis.splitLine.show" :label="['开', '关']" size="small"/>
          </t-form-item>
        </div>
      </e-collapse>
      <e-collapse title="y轴" :expand="false">
        <t-form-item label="y轴">
          <t-switch v-model="attribute.yAxis.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <div v-show="attribute.yAxis.show">
          <t-form-item label="y轴指示文字">
            <t-input v-model="attribute.yAxis.name" size="small" :maxcharacter="40"/>
          </t-form-item>
          <t-form-item label="y轴线显示">
            <t-switch v-model="attribute.yAxis.axisLine.show" :label="['开', '关']" size="small"/>
          </t-form-item>
          <t-form-item label="y轴颜色">
            <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.yAxis.axisLine.lineStyle.color" size="small"/>
          </t-form-item>
          <t-form-item label="y轴网格线">
            <t-switch v-model="attribute.yAxis.splitLine.show" :label="['开', '关']" size="small"/>
          </t-form-item>
          <t-form-item label="y轴刻度线">
            <t-switch v-model="attribute.yAxis.axisTick.show"  :label="['开', '关']" size="small"/>
          </t-form-item>
          <t-form-item label="y轴字体颜色">
            <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.yAxis.axisLabel.color" size="small"/>
          </t-form-item>
          <t-form-item label="y轴字号">
            <t-input-number v-model="attribute.yAxis.axisLabel.fontSize" :min="1" :max="100" size="small" :decimal-places="0"/>
          </t-form-item>
        </div>
      </e-collapse>
      <e-collapse title="数值" :expand="false">
        <t-form-item label="数值显示">
          <t-switch v-model="attribute.series.label.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <div v-show="attribute.series.label.show">
          <t-form-item label="数值字体">
            <t-input-number v-model="attribute.series.label.fontSize" :min="2" :max="100" size="small" :decimal-places="0"/>
          </t-form-item>
          <t-form-item label="数值颜色" v-show="attribute.series.label.color">
            <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.series.label.color" size="small"/>
          </t-form-item>
          <t-form-item label="数值位置" v-show="attribute.series.label.position">
            <t-select v-model="attribute.series.label.position" size="small">
              <t-option label="顶部" value="top"/>
              <t-option label="左" value="left"/>
              <t-option label="右" value="right"/>
              <t-option label="底部" value="bottom"/>
              <t-option label="中心" value="inside"/>
            </t-select>
          </t-form-item>
        </div>
      </e-collapse>
      <e-collapse title="柱体" :expand="true">
        <t-form-item label="柱体宽度">
          <t-input-number v-model="attribute.series.barWidth" :min="1" :max="100" size="small" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="配色">
          <div>
            <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.color[0]" enableAlpha size="small"/>
            <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.color[1]" enableAlpha size="small"/>
            <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.color[2]" enableAlpha size="small"/>
            <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.color[3]" enableAlpha size="small"/>
          </div>
        </t-form-item>
      </e-collapse>
      <t-form-item label="X轴拖动" v-if="attribute.dataZoom">
         <t-switch v-model="attribute.dataZoom.show"/> 
      </t-form-item>
      <t-form-item label="X轴拖动高度" v-if="attribute.dataZoom && attribute.dataZoom.show">
        <t-input-number v-model="attribute.dataZoom.height" :min="0" :max="50" size="small" :decimal-places="0"/>
      </t-form-item>
    </t-form>
  </div>
</template>

<script>
import CptData from '@/components/element/options/comp/cpt-data'
import EChartPosition from "@/components/designer/e-chart-position";
export default {
  name: "cpt-chart-column-stereo-option",
  components: {EChartPosition,CptData},
  props: {
    attribute: Object,
    cptDataForm:Object,
  },
}
</script>

<style scoped>

</style>
